import Qs from 'qs';
import { Toast } from 'vant';
Toast.allowMultiple();

const { VUE_APP_BASE_URL, NODE_ENV } = process.env;

export default {
  baseURL: VUE_APP_BASE_URL,

  defaultErrorMessage: '网络错误，请稍后重试',
  errorMessageFn: Toast,

  responseStatusKey: 'resultCode', // 服务端返回的代表状态的字段名
  responseSuccessStatus: 0, // 代表成功状态的status

  responseMessageKey: 'resultMsg', // 服务端返回的代表信息的字段名

  responseCode: {
    // 服务器返回数据，特殊status
    '10600000'({ data }) {
      // ${ response.data }     do something
    },
  },

  get downloadUrl() {
    const url = 'https://u2.jr.jd.com/downloadApp/index.html?';
    const params = {
      id: '6702',
      activityId: '3855',
      jumpType: '7',
      jumpUrl: encodeURIComponent(window.location.href),
    };

    return url + Qs.stringify(params);
  },
  downloadUrl2(contentId) {
    console.log(contentId);
    const url = 'https://u2.jr.jd.com/downloadApp/index.html?';

    const gotoUrl =
      location.host == 'minner.jr.jd.com'
        ? `https://minner.jr.jd.com/video/appointment/index.html?contentId=${contentId}`
        : `https://content.jr.jd.com/video/appointment/index.html?contentId=${contentId}`;

    // const gotoUrl = `https://content.jr.jd.com/video/appointment/wechart.html?contentId=${contentId}`
    // const gotoUrl = `https://minner.jr.jd.com/video/appointment/wechart.html?contentId=${contentId}`
    const params = {
      id: '6702',
      activityId: '',
      jumpType: '7',
      jumpUrl: gotoUrl,
    };

    return url + Qs.stringify(params);
  },
};
